import * as React from 'react';
import { IconChevronDown, IconLoader2 } from "@tabler/icons-react";
import { Select, SelectItem, SelectProps } from "@mantine/core";
import styles from './searchable-select.module.scss';
import { useDebouncedState } from "@mantine/hooks";
import qs from "qs";
import axios from "axios";
import { IResponse } from "../../types/api";

interface CustomSelectProps extends Omit<SelectProps, 'data'>{
    value?: string | null;
}

interface ISearchableSelectProps<T> {
    debounce?: number;
    selectProps: CustomSelectProps;
    uri: string;
    parser: (item: T, index: number) => SelectItem;
}

function SearchableSelect<T>({
    selectProps,
    debounce = 500,
    uri,
    parser
}: ISearchableSelectProps<T>) {

    const ref = React.useRef<HTMLInputElement>(null);

    const [ searchQuery, setSearchQuery ] = useDebouncedState('', debounce);
    const [ items, setItems ] = React.useState<T[]>([]);
    const [ isLoading, setIsLoading ] = React.useState<boolean>(false);
    const [ selected, setSelected ] = React.useState<any>({  });
    const [ isFocused, setIsFocused ] = React.useState(false);

    const data: SelectItem[] = React.useMemo(() => {
        return items.map(parser)
    }, [items]);

    React.useEffect(() => {
        if (selectProps.value) {
            const selectedItem = data.find(item => item.value === selectProps.value);
            if (selectedItem) {
                setSelected(selectedItem);
            }
        } else {
            setSelected(null);
        }
    }, [selectProps.value])

    React.useEffect(() => {
        if (searchQuery) {
            void handleSearch()
        } else {
            // onClear();
        }
    }, [searchQuery]);

    const handleSearch = async () => {
        try {
            setIsLoading(true);
            const params = {
                query: searchQuery,
            }
            const queryParams = qs.stringify(params);
            const { data: responseData } = await axios.get<IResponse<T[]>>(`${uri}?${queryParams}`, { silent: true });
            setItems(responseData.result ?? []);
        } catch (e) {
            if (e instanceof Error) {
                console.log('Searchable Select Search Error: ', e.message);
            }
        } finally {
            setIsLoading(false);

        }

    }

    const selectData = [];
    if (selected) {
        selectData.push(selected);
    }
    selectData.push(...data);

    const getSearchValue = (): string | undefined => {
        if (isFocused) {
            return undefined;
        }
        if (selected) {
            return selected.label;
        }
        if (selectProps.value) {
            return selectProps.value
        }
        return undefined;
    }

    return (
        <Select
            ref={ref}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={30}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            searchable
            clearable
            icon={isLoading && <IconLoader2 className={styles.loader}/>}
            onSearchChange={query => !isLoading && setSearchQuery(query.toLowerCase())}
            placeholder='Хайх...'
            // onDropdownClose={onClear}
            searchValue={getSearchValue()}
            filter={() => true}
            data={selectData}
            {...selectProps}
            onFocus={() => {
                setIsFocused(true);
            }}
            onBlur={() => {
                setIsFocused(false);
            }}
        />
    )
}

export default SearchableSelect;